<div class="sidenav-content">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="ecallData">
				<copo-panel-header class="title" headerTextSeparator="      "
					[titleHeaderText]="'ecall-off.ecall-card' | translate"
					(backButtonClick)="goBack()">
				</copo-panel-header>
				<div class="grid-6 copo-container card-info-block">
					<div class="grid-column-one-full">
						<div class="call-off-infoentry-form-row">
							<div>
								<div class="card-content-label" translate>ecall-off.customer-call-off-reference</div>
								<div class="card-content-value">{{ecallData.customerCallOffReference ?
									ecallData.customerCallOffReference : UNDERSCORE}}</div>
							</div>
							<div>
								<div class="card-content-label" translate>ecall-off.rdd-mode</div>
								<div class="card-content-value">{{ ecallData.requestedDateForCallOffType ?? UNDERSCORE }}</div>
							</div>
							<div>
								<div class="card-content-label" translate>ecall-off.copy-to</div>
								<div class="card-content-value">{{ecallData.copyTo ? ecallData.copyTo : UNDERSCORE}}
								</div>
							</div>
							<div>
								<div class="card-content-label" translate>ecall-off-creation-date</div>
								<div class="card-content-value">{{ (ecallData.callOffCreationTimestamp ? ecallData.callOffCreationTimestamp : UNDERSCORE) | copoDate: 'date'}}</div>
							</div>
						</div>

						<div class="call-off-infoentry-simple-row">
							<span class="center-alignment">
								<div class="copo-request-text">{{ totalRequestedQuantity | copoNumber:'weight':'t' }}</div>
								<div class="copo-grey-text" translate>ecall-off.total-material-request</div>
							</span>
							<!-- nb called batches -->
							<span *ngIf="isBatchCallOff"
								class="center-alignment">
								<div class="copo-request-text">
									<span>{{ecallData.items.length}}</span>
									<span>&nbsp;</span>
									<span translate>ecall-off.batches</span>
								</div>
								<div class="copo-grey-text" translate>eoffer.requested</div>
							</span>
							<!-- nb called order items -->
							<span *ngIf="!isBatchCallOff"
								class="center-alignment">
								<div class="copo-request-text">
									<span>{{ecallData.items.length}}</span>
									<span>&nbsp;</span>
									<span translate>ecall-off.order-items</span>
								</div>
								<div class="copo-grey-text" translate>eoffer.requested</div>
							</span>
						</div>
					</div>
				</div>
				<!-- batches -->
				<div *ngIf="isBatchCallOff && groupCalledBatch.length > 0"
					class="card-title-block-non-sticky">
					<div class="card-title-label">
						<span translate>ecall-off.called-batches</span>
						<span>&#58;</span>
					</div>
				</div>
				<div class="padding-bottom ecall-alignment-margin copo-container card-info-block" *ngFor="let group of groupCalledBatch">
					<div class="grid-6">
						<div class="grid-column-one-full">
							<div class="call-off-infoentry-form-row">
								<div class="call-off-infoentry-icon">
									<mat-icon class="row-icon certificate-info-label"
										svgIcon="at_consignment"></mat-icon>
									<span *ngIf="isBatchCallOff">
										{{group.millDescription}}
									</span>
								</div>
								<div>
									<div class="card-content-label" translate>ecall-off-card-gross-quantity</div>
									<span class="center-alignment text-display-orange">
									<div class="copo-request-text">{{group.grossWeight !== undefined ?
										(group.grossWeight | copoNumber:'weight':'t') : UNDERSCORE}}</div>
									</span>
								</div>
								<div>
									<div class="card-content-label" translate>ecall-off-card-net-quantity</div>
									<div>
										<span class="center-alignment text-display-orange">
											<div class="copo-request-text">{{group.netWeight !== undefined ?
												(group.netWeight | copoNumber:'weight':'t') : UNDERSCORE}}</div>
											</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div *ngFor="let batch of group.millCodeGroup; let i = index;" >
						<div class="grid-column-one-full copo-container ecall-background-color card-block-ecall grid-container card-portal grid-6">
							<div class="card-column copo-bottom-margin">
								<div class="batch-label" translate>commercial-documents.batch-number</div>
								<div class="card-content-value-cursor">
									<a class="ecall-card-value-color"
										[routerLink]="['/order-tracking/batch/card/', batch.supplierBatchReference]">
										{{batch.batchReference ? batch.batchReference : UNDERSCORE}}
									</a>
								</div>
							</div>
							<div class="card-column copo-bottom-margin">
								<div>
									<span class="tag-tonnage" [title]="'batch-card.gross-weight' | translate">
										{{ batch.qtyBatchBrut | copoNumber:'weight':'t' }}
									</span>
								</div>
							</div>
							<div class="card-column">
								<div translate class="batch-label">ecall-off.unloading-reference</div>
								<div class="card-content-value">{{batch.unloadingReference ? batch.unloadingReference :
									UNDERSCORE}}</div>
							</div>
							<div class="card-column copo-bottom-margin">
								<div class="batch-label" translate>commercial-documents.customer-order-number
								</div>
								<a class="ecall-card-value-color"
									[routerLink]="['/order-tracking/order/card/', batch.supplierOrderNumber, batch.supplierOrderItemNumber]">
									{{ getBatchCustomerOrderDisplay(batch) }}
								</a>
							</div>
							<div class="card-column copo-bottom-margin">
								<div class="batch-label" translate>batch-card.batch-status</div>
								<div class="card-content-value">
									{{ batch.batchStatusDescription ? batch.batchStatusDescription : UNDERSCORE }}
								</div>
							</div>
							<div class="card-column copo-bottom-margin">
								<div class="batch-label" translate>batch-card.customer-article-reference
								</div>
								<div class="card-content-value">
									{{batch.customerArticleReference ? batch.customerArticleReference : UNDERSCORE}}
								</div>
							</div>
							<div class="card-column">
								<div translate class="batch-label">ecall-off.ship-to</div>
								<div class="card-content-value">{{batch.shipToDescription ? 
									batch.shipToDescription : UNDERSCORE}}</div>
							</div>
							<div class="card-column">
								<div translate class="batch-label">ecall-off.requested-ship-to</div>
								<div class="card-content-value">{{batch.callOffShipToDescription ? 
									batch.callOffShipToDescription : UNDERSCORE}}</div>
							</div>
							<div class="card-column">
								<div translate class="batch-label">ecall-off-call-creater</div>
								<div class="card-content-value">{{ecallData.callOffCreator ?
									ecallData.callOffCreator : UNDERSCORE}}</div>
							</div>
							<div class="card-column"
								*ngIf="isReqDateVisible && !isFromToDateVisible && !batch.batchCancellationTimestamp">
								<div translate class="batch-label">ecall-off.requested-date</div>
								<div class="card-content-value">{{(ecallData.requestedDateForCallOffType === 'EARLIEST' ?
									batch.requestedDeliveryDateFrom : ecallData.requestedDateForCallOffType === 'LATEST' ?
									batch.requestedDeliveryDateTo : UNDERSCORE) | copoDate:'date'}}</div>
							</div>
							<div class="card-column" *ngIf="!isReqDateVisible && isFromToDateVisible && !batch.batchCancellationTimestamp">
								<div translate class="batch-label">filter.number.from</div>
								<div class="card-content-value">{{(ecallData.requestedDateForCallOffType === 'ASAP' ? (batch.callOffItemCreationTimestamp || batch.requestedDeliveryDateFrom) : batch.requestedDeliveryDateFrom) || UNDERSCORE | copoDate:'date'}}</div>
								<div class="card-column" *ngIf="!isReqDateVisible && isFromToDateVisible && ecallData.requestedDateForCallOffType !== 'ASAP' && !batch.batchCancellationTimestamp">
									<div translate class="batch-label">filter.date.to</div>
									<div class="card-content-value">{{(batch.requestedDeliveryDateTo ?
										batch.requestedDeliveryDateTo : UNDERSCORE) | copoDate:'date'}}</div>
								</div>
							</div>
							<div class="card-column" *ngIf="batch.batchCancellationTimestamp">
								<div translate class="batch-label">ecall-off.canceled</div>
								<div class="card-content-value cancellation-date">{{batch.batchCancellationTimestamp |
									copoDate:'date'}}</div>
							</div>
							@if (batch.comment) {
							<div class="card-row card-header-double-span" *ngIf="showComments">
								<span  class="copo-right-comment-margin">
									<mat-icon svgIcon="comment"></mat-icon>
								</span>
								<div class="card-content-value">{{batch.comment}}</div>
							</div>
							}
						</div>
					</div>
				</div>
				<!-- order items for calloff by volume -->
				<div *ngIf="!isBatchCallOff && groupCalledVolume.length > 0"
					class="card-title-block-non-sticky">
					<div class="card-title-label">
						<span translate>ecall-off.called-order-items</span>
						<span>&#58;</span>
					</div>
				</div>
				<div class="padding-bottom copo-container card-info-block card-block-ecall" *ngFor="let group of groupCalledVolume">
					<div class="grid-6">
						<div class="grid-column-one-full">
							<div class="call-off-infoentry-form-row">
								<div class="call-off-infoentry-icon" *ngIf="group.millCodeGroup && group.millCodeGroup.length > 0">
									<mat-icon class="row-icon certificate-info-label"
									svgIcon="at_consignment"></mat-icon>
									{{group.millDescription ? group.millDescription : UNDERSCORE}}
								</div>
								<div>
									<div class="card-content-label" translate>eoffer.cart.volume.request</div>
									<div>
										<span class="center-alignment text-display-orange">
											<div class="copo-request-text">{{group.requestedVolume !== undefined ?
												(group.requestedVolume | copoNumber:'weight':'t') : UNDERSCORE}}</div>
											</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div *ngFor="let volumes of group.millCodeGroup; let i = index;">
						<ng-container *ngIf="!isBatchCallOff && group.millCodeGroup.length > 0">
							<copo-called-volume [showComment]="showComments" [volume]="volumes"></copo-called-volume>
						</ng-container>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>